(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("default-light-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["default-light-panelless"] = factory();
	else
		root["SurveyTheme"] = factory();
})(this, function() {
return 